export const APP_VERSION = '3.8.0';
